<template>
  <svg>
    <circle :class="modalTheme" :r="pieChart.getInnerRadius() - 3" cx="100" cy="100" />
    <text :class="modalTheme" text-anchor="middle" x="100" y="100">
      <!-- <tspan x="100" fill="#e3f4e5">{{ country.status }} </tspan> -->
      <tspan :style="{ fontWeight: 900 }" style="font-size: large; font-weight: 900" x="100" dy="5px">
        {{ total }}
      </tspan>
    </text>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, toRefs } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

const formatNumber = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
}).format;

const props = defineProps({
  pieChart: {
    type: Object,
    default: () => ({}),
  },
  total: {
    type: Number,
    default: 0,
  },
});

const country = computed(() => {
  const series = props.pieChart.getAllSeries?.();
  const points = series?.[0]?.getVisiblePoints?.();
  return points?.[0]?.data || {};
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);

function getImagePath(country) {
  return `images/flags/${country.replace(/\s/, "").toLowerCase()}.svg`;
}

function calculateTotal(pieChart) {
  const series = pieChart.getAllSeries?.();
  const points = series?.[0]?.getVisiblePoints?.();
  return formatNumber(points?.reduce((s, p) => s + p.originalValue, 0) || 0);
}

onMounted(() => {
  // console.log("onMounted() :      CenterTemplate      >>>>");
  // console.log("modalTheme");
  // console.log(modalTheme.value);
});
</script>
